import React from 'react';

import './CommerceLinksEmptyPlaceholder.css';

const CommerceLinksEmptyPlaceholder = () => (
  <div className="commerce-links-empty-placeholder__component">
    <div className="placeholder-image" />
    <div className="undertext">
      You haven't added any Commerce Links yet.
      To do so just press button above and follow the instructions.
    </div>
  </div>
);

export default CommerceLinksEmptyPlaceholder;
